import request from "@/utils/request";

// 创建WhatsApp二维码
export function createWhatsAppQr(params, config) {
    return request.post('/whatsApp/user/createQr', params, {
        responseType: 'blob',
        ...(config || {})
    })
}

// 获取WhatsApp用户信息
export function getUserInfoBySession(params, config) {
    return request.get('/whatsApp/user/getUserInfoBySession', params, {
        ...(config || {})
    })
}

// 退出登录
export function logout(params, config) {
    return request.get('/whatsApp/user/logout', params, {
        ...(config || {})
    })
}

// 获取当前用户所有的聊天记录
export function getAllMessage(params, config) {
    return request.post('/whatsApp/message/getMessageOverview', params, {
        ...(config || {})
    })
}

//获取指定用户的聊天记录
export function getMessageByChatId(params, config) {
    return request.post('/whatsApp/message/getMessageByChatId', params, {
        ...(config || {})
    })
}


//聊天信息置顶
export function topMessageByMessageId(params, config) {
    return request.get('/whatsApp/message/topMessageByMessageId', params, {
        ...(config || {})
    })
}

//取消聊天信息置顶
export function unTopMessageByMessageId(params, config) {
    return request.get('/whatsApp/message/unTopMessageByMessageId', params, {
        ...(config || {})
    })
}

// 转发消息
export function forwardMessage(params, config) {
    return request.post('/whatsApp/send/message/forwardMessage', params, {
        ...(config || {})
    })
}

// 发送按钮回复消息
export function sendButtonsReply(params, config) {
    return request.post('/whatsApp/send/message/sendButtonsReply', params, {
        ...(config || {})
    })
}

// 发送消息反应（对消息添加表情反应）
export function sendReaction(params, config) {
    return request.post('/whatsApp/send/message/sendReaction', params, {
        ...(config || {})
    })
}

// 发送文件消息
export function sendFile(params, config) {
    return request.post('/whatsApp/send/message/sendFile', params, {
        timeout: 1800000,
        ...(config || {})
    })
}

// 发送图片消息
export function sendImage(params, config) {
    return request.post('/whatsApp/send/message/sendImage', params, {
        ...(config || {})
    })
}


// 发送文本消息
export function sendText(params, config) {
    return request.post('/whatsApp/send/message/sendText', params, {
        ...(config || {})
    })
}

// 开始输入状态（向指定聊天发送正在输入的通知）
export function startTyping(params, config) {
    return request.post('/whatsApp/send/message/startTyping', params, {
        ...(config || {})
    })
}

// 停止输入状态（向指定聊天发送停止输入的通知）
export function stopTyping(params, config) {
    return request.post('/whatsApp/send/message/stopTyping', params, {
        ...(config || {})
    })
}

// 获取所有联系人
export function getAllContact(params, config) {
    return request.post('/whatsApp/contact/getAllContact', params, {
        ...(config || {})
    })
}

//删除对应的消息
export function deleteMessageByMessageId(params, config) {
    return request.get('/whatsApp/message/deleteMessageByMessageId', params, {
        ...(config || {})
    })
}

// 编辑对应的消息
export function updateMessageByMessageId(params, config) {
    return request.get('/whatsApp/message/updateMessageByMessageId', params, {
        ...(config || {})
    })
}

//获取所有群组
export function getAllGroup(params, config) {
    return request.post('/whatsApp/group/getAllGroup', params, {
        ...(config || {})
    })
}

// 获取群组中的成员列表
export function getGroupParticipants(params, config) {
    return request.get('/whatsApp/group/getGroupParticipantsV2', params, {
        ...(config || {})
    })
}

//清空与某人的聊天记录
export function deleteAllMessageByChatId(params, config) {
    return request.get('/whatsApp/message/deleteAllMessageByChatId', params, {
        ...(config || {})
    })
}

//退出群组
export function leaveGroup(params, config) {
    return request.get('/whatsApp/group/leaveGroup', params, {
        ...(config || {})
    })
}

//获取群组头像
export function getGroupPicture(params, config) {
    return request.get('/whatsApp/group/getGroupPicture', params, {
        ...(config || {})
    })
}

// 通过 lid 查询 us 信息
export function getUsByLid(params, config) {
    return request.get('/whatsApp/contact/getUsByLid', params, {
        ...(config || {})
    })
}

// 通过 contactId 查询联系人信息
export function getContactInfoByContactId(params, config) {
    return request.get('/whatsApp/contact/getContactInfoByContactId', params, {
        ...(config || {})
    })
}

// 通过手机号，查询 us 和 lid
export function getLidAndUsByPhone(params, config) {
    return request.get('/whatsApp/contact/getLidAndUsByPhone', params, {
        ...(config || {})
    })
}

//发送已读回执
export function sendSeen(params, config) {
    return request.post('/whatsApp/send/message/sendSeen', params, {
        ...(config || {})
    })
}

// 添加WhatsApp附件
export function addWhatsAppExtend(params, config) {
    return request.post('/whatsApp/mailWhatsappExtend/add', params, {
        ...(config || {})
    })
}

// 查询WhatsApp附件列表
export function getWhatsAppExtendList(params, config) {
    return request.post('/whatsApp/mailWhatsappExtend/queryPageList', params, {
        ...(config || {})
    })
}

// 批量删除WhatsApp附件
export function deleteWhatsAppExtendBatch(params, config) {
    return request.post('/whatsApp/mailWhatsappExtend/deleteBatch', params, {
        ...(config || {})
    })
}

//获取所有的标签
export function getAllLabel(params, config) {
    return request.get('/whatsApp/contact/getAllLabel', params, {
        ...(config || {})
    })
}

//根据标签获取聊天记录
export function getMessageByLabelId(params, config) {
    return request.get('/whatsApp/contact/getMessageByLabelId', params, {
        ...(config || {})
    })
}

//通过id删除附件
export function deleteWhatsAppExtendById(params, config) {
    return request.delete('/whatsApp/mailWhatsappExtend/delete', params, {
        ...(config || {})
    })
}

//同步数据接口
export function updateUserContactInfo(params, config) {
    return request.get('/whatsApp/user/updateUserContactInfo', params, {
        ...(config || {})
    })
}

//发送链接的消息
// export function sendLinkCustomPreview(params, config) {
//     return request.post('/whatsApp/send/message/sendLinkCustomPreview', params, {
//         ...(config || {})
//     })
// }
export function sendLinkCustomPreview(params, config) {
    return request.post('/whatsApp/send/message/sendText', params, {
        ...(config || {})
    })
}

// 根据聊天ID和消息ID获取消息
export function getMessageByChatIdAndMessageId(params, config) {
    return request.post('/whatsApp/message/getMessageByChatIdAndMessageId', params, {
        ...(config || {})
    })
}